import { useAuth } from '@/features/auth/useAuth'
import { formatMoney } from '@/utils/format'

/** Money formatter bound to the school's currency. */
export function useMoney(): {
  currency: string
  money: (value: string | number | null | undefined) => string
} {
  const currency = useAuth().school?.currency ?? 'USD'
  return { currency, money: (value) => formatMoney(value, currency) }
}
